import React from 'react';

import { constants, getTextDialFilterIndexes } from '@trqk/utils';

import { TextDial } from '..';

const { broadcastVsDigitalOptions } = constants;

const filterOptions = Array.from(broadcastVsDigitalOptions.values());

/**
 * @typedef {BroadcastVsDigitalFilterProps}
 * @property {DropdownOption<BroadcastOrDigital>} filterOption
 * @property {function} setFilterOption a state update function to set the current filter option
 */
interface BroadcastVsDigitalFilterProps {
    filterOption: DropdownOption<BroadcastOrDigital>;
    setFilterOption(nextFilterOption: DropdownOption<BroadcastOrDigital>): void;
}

/**
 * Displays a TextDial that allows the user to select between "Broadcast / Other" and "Digital".
 * @param {BroadcastVsDigitalFilterProps}
 */
export const BroadcastVsDigitalFilter = ({
    filterOption,
    setFilterOption,
}: BroadcastVsDigitalFilterProps): JSX.Element => (
    <TextDial
        currentOption={filterOption}
        onClick={(): void => {
            const { nextFilterIndex } =
                getTextDialFilterIndexes<BroadcastOrDigital>(
                    filterOptions,
                    filterOption,
                );

            setFilterOption(filterOptions[nextFilterIndex]);
        }}
    />
);
